import {uniqBy} from 'lodash'

export default function(angularModule) {
  angularModule.controller(
    'billingAccountEditorCtrl',
    function(
      $scope, billingAccount, billingAccountsService, $uibModalInstance, $log
    ) {

    $scope.form = {}
    $scope.loadTags = (q) => billingAccountsService.queryTags(q);
    $scope.selectedTags = billingAccount.tags ? billingAccount.tags.map(text => ({ text })) : [];
    $scope.title = billingAccount._id ? 'Edit Billing Account' : 'Create Billing Account';
    $scope.billingAccount = Object.assign({}, billingAccount);
    $scope.assignees = groupedAssignees(billingAccount.assignedTo)

    $scope.canAddAssignee = (type) => {
      let noAssignees = !$scope.assignees[type].list.length
      let hasEmptyRows =  !noAssignees && $scope.assignees[type].list.filter(rowEmpty).length
      return noAssignees || ($scope.assignees[type].list.length && !hasEmptyRows && !hasDupeEmails(type))
    }

    $scope.addAssignee = (type) => {
      $scope.assignees[type].list.push({name:'', email: '', employeeType: type})
    }

    function rowEmpty(assignee,strict) {
      function isOrAnd(cond1,cond2,strict) {
        return strict ? cond1 && cond2 : cond1 || cond2
      }
      return isOrAnd(!assignee.name || assignee.name === '',!assignee.email || assignee.email === '',strict)
    }

    function hasDupeEmails(type) {
      return $scope.assignees[type].list.length !== uniqBy($scope.assignees[type].list,'email').length
    }

    $scope.removeAssignee = (index,type) => {
      $scope.assignees[type].list.splice(index, 1);
    }

    $scope.billingTypes = [
      'Customer', 'Demo', 'Test'
    ];
    $scope.saving = false;

    $scope.addContact = () => {
      $scope.billingAccount.contact = {
        firstName: "",
        lastName: "",
        email: "",
        address: {
          line1:      "",
          line2:      "",
          city:       "",
          state:      "",
          country:    "",
          postalCode: ""
        }
      }
    };

    // contact required when creating account
    if (!billingAccount._id) $scope.addContact();

    function submit() {
      if ($scope.selectedTags && $scope.selectedTags.length > 0) {
        $scope.billingAccount.tags = $scope.selectedTags.map(obj => obj.text)
      } else {
        $scope.billingAccount.tags = null;
      }

      $scope.billingAccount.assignedTo = flattenedAssignees($scope.assignees)

      return billingAccount._id ?
        billingAccountsService.update(billingAccount._id, $scope.billingAccount) :
        billingAccountsService.create($scope.billingAccount);
    }

    function groupedAssignees(assignedTo) {
      return {
        salesExecs: {
          list: assignedTo && assignedTo.filter(a => a.employeeType === 'SalesExecutive').length ? assignedTo.filter(a => a.employeeType === 'SalesExecutive') : [{name:'', email: '', employeeType: 'SalesExecutive'}]
        },
        csms: {
          list: assignedTo && assignedTo.filter(a => a.employeeType === 'CustomerSuccessManager').length ? assignedTo.filter(a => a.employeeType === 'CustomerSuccessManager') : [{name:'', email: '', employeeType: 'CustomerSuccessManager'}]
        },
        obss: {
          list: assignedTo && assignedTo.filter(a => a.employeeType === 'OnboardingSpecialist').length ? assignedTo.filter(a => a.employeeType === 'OnboardingSpecialist') : [{name:'', email: '', employeeType: 'OnboardingSpecialist'}]
        },
        listingManagementSpecialists: {
          list: assignedTo && assignedTo.filter(a => a.employeeType === 'ListingManagementSpecialist').length ? assignedTo.filter(a => a.employeeType === 'ListingManagementSpecialist') : [{name:'', email: '', employeeType: 'ListingManagementSpecialist'}]
        }
      }
    }

    function flattenedAssignees(assignees) {
      let flattenedSalesExecs = assignees.salesExecs.list.map(a => ({...a,employeeType:'SalesExecutive'}))
      let flattenedCSMs = assignees.csms.list.map(a => ({...a,employeeType:'CustomerSuccessManager'}))
      let flattenedOBSs = assignees.obss.list.map(a => ({...a,employeeType:'OnboardingSpecialist'}))
      let flattenedListingManagementSpecialists = assignees.listingManagementSpecialists.list.map(a => ({...a,employeeType:'ListingManagementSpecialist'}))
      let joined = flattenedSalesExecs.concat(flattenedCSMs).concat(flattenedOBSs).concat(flattenedListingManagementSpecialists).filter(assn => !rowEmpty(assn))
      return joined.length ? joined : null
    }

    function typeValid(type) {
      let collection = $scope.assignees[type].list
      let formValid = $scope.form.editor.assigneesForm[type].$valid
      return collection.length === 0 ||
       (collection.length === 1 && (rowEmpty(collection[0], true) || formValid)) ||
       (collection.length > 1 && ((collection.filter(assn => (rowEmpty(assn,true))).length === 0 && !hasDupeEmails(type)) && formValid))
    }

    $scope.disableSubmit = () => {
      return !typeValid('salesExecs') || !typeValid('listingManagementSpecialists') || !typeValid('csms' || !typeValid('obss'))
    }

    $scope.cancel = () => {
      $uibModalInstance.dismiss('Cancel Button');
    };

    $scope.save = () => {
      if ($scope.billingAccount.status === undefined) {
        const theError = new Error("'Client Type' is required")
        $scope.error = theError
        $scope.errorMsg = theError.message
        return;
      }

      $scope.saving = true;
      submit().then(
        (success) => $uibModalInstance.close(true),
        (error) => {
          $log.error(error);
          $scope.saving = false;
          $scope.error = error;
        }
      )
    };
  })
}
